<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div :class="`vx-row ${filtroAvancado == true ? '' : 'pb-6 mb-0'}`">
          <div :class="`vx-col sm:w-1/4 w-full`">
            <span>Nome Benefeciario / Cliente</span>
            <vs-input
              class="w-full"
              name="Nome"
              id="Nome"
              v-model="formFiltro.nomeAssociado"
              :state="validateState('Nome')"
              :danger="validateClass('Nome')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div :class="`vx-col sm:w-1/5 w-full`">
            <span>Cpf / CNPJ</span>
            <vs-input
              class="w-full"
              name="cpfcnpj"
              id="cpfcnpj"
              v-model="formFiltro.cpfcnpj"
              :state="validateState('cpfcnpj')"
              :danger="validateClass('cpfcnpj')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <span>Data Inicial</span>
            <vx-input-group class="mb-base">
              <template slot="prepend">
                <v-select
                  style="width: 250px"
                  :options="tiposDatas"
                  v-model="formFiltro.tipoData"
                ></v-select>
              </template>

              <datepicker
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                v-model="formFiltro.dataInicial"
              ></datepicker>
            </vx-input-group>
          </div>

          <div class="vx-col sm:w-1/5 w-full">
            <span>Data Final</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
            ></datepicker>
          </div>
        </div>
        <div v-if="filtroAvancado == true" class="vx-row pb-10">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Status Cobrança</span>
            <v-select
              :options="statusRegistrosFinanceiros"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.statusCobranca"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>Tipo</span>
            <v-select
              :options="tipos"
              name="Tipo"
              id="Tipo"
              v-model="formFiltro.tipo"
              :state="validateState('Tipo')"
              :class="validateClass('Tipo')"
            ></v-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>Forma de Pagamento</span>
            <v-select
              :options="formasPagamento"
              name="Forma de Pagamento"
              id="Forma de Pagamento"
              multiple
              v-model="formFiltro.formaPagamento"
              :state="validateState('Forma de Pagamento')"
              :class="validateClass('Forma de Pagamento')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            <span>Origem</span>
            <v-select
              :options="origem"
              multiple
              name="Origem"
              id="Origem"
              v-model="formFiltro.origem"
              :state="validateState('Origem')"
              :class="validateClass('Origem')"
            ></v-select>
          </div>
        </div>
        <div v-if="filtroAvancado == true" class="vx-row pb-10">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Status Beneficiário</span>
            <v-select
              :options="filtraArray('Beneficiários')"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.statusBeneficiario"
              label="nomeStatus"
              :reduce="(StatusBeneficiario) => StatusBeneficiario.nomeStatus"
            ></v-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>Status Cliente</span>
            <v-select
              :options="filtraArray('Clientes')"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.statusCliente"
              label="nomeStatus"
              :reduce="(StatusCliente) => StatusCliente.nomeStatus"
            ></v-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>Tipo de Baixa</span>
            <v-select
              :options="tipoBaixa"
              name="Tipo de Baixa"
              id="Tipo de Baixa"
              v-model="formFiltro.tipoBaixa"
              :state="validateState('Tipo de Baixa')"
              :class="validateClass('Tipo de Baixa')"
            ></v-select>
          </div>
        </div>
      </form>
      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            @click="filtroAvancado = !filtroAvancado"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../services";
import BotaoSubmit from "../../../components/BotaoSubmit";
import utilsList from "./../../../utils/list";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  watch: {},
  data() {
    return {
      aguardeCadastro: false,
      idDistribuidor: null,
      decoded: utilsList.buscaToken(),
      formasPagamento: [],
      statusCobranca: [],
      rateios: [],
      statusVeiculo: [],
      statusRegistrosFinanceiros: [],
      consultores: [],
      regionais: [],
      languages: lang,
      filtroAvancado: false,
      tipos: ["Avulso", "Fechamento", "Proposta"],
      boletoFisico: ["Sim", "Não"],
      tipoBaixa: ["Automática", "Manual"],
      tiposDatas: [
        "Data Emissão",
        "Data Vencimento",
        "Data Vencimento Original",
        "Data Pagamento",
      ],
      origem: ["Cliente", "Beneficiário"],
      estado: null,
      funcoesValicao: null,
      formFiltro: {
        idDistribuidor: null,
        placa: null,
        nomeAssociado: null,
        cpfcnpj: null,
        chassi: null,
        status: null,
        tipo: null,
        formaPagamento: null,
        origem: null,
        tipoData: "Data Emissão",
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        statusVeiculo: null,
        statusAssociado: null,
        boletoFisico: null,
        tipoBaixa: null,
      },
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        placa: null,
        nomeAssociado: null,
        cpfcnpj: null,
        chassi: null,
        status: null,
        tipo: null,
        formaPagamento: null,
        origem: null,
        tipoData: "Data Emissão",
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        statusVeiculo: null,
        statusAssociado: null,
        boletoFisico: null,
        tipoBaixa: null,
      };
      this.buscar();
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 1);
      return b;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == "status" && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    filtraArray(tipo, adiciona = false) {
      var arr = this.status.filter(
        (x) => x.tipoStatus == null || x.tipoStatus == tipo
      );

      if (tipo == "Propostas") {
        arr = arr.filter((x) => x.tipoStatus == tipo);
      }

      if (adiciona == true) {
        arr.push({ idSituacao: null, nomeStatus: "Sem Alteração" });
      }
      return arr;
    },
    buscaSituacoes(tipo = "todos") {
      this.$vs.loading();
      service.getAll("Situacao", {}, "Situacoes/" + tipo).then((res) => {
        console.log(res.data);
        if (res.data.length > 0) {
          console.log(res.data);
          this.status = [];
          res.data.forEach((element) => {
            if (
              element.tipoStatus == "Beneficiários" ||
              element.tipoStatus == null
            )
              this.status.push(element);
          });
          this.$vs.loading.close();
        } else {
          this.$vs.loading.close();
        }
      });
    },
    buscaDadosConsultor() {
      service.getAll("Usuario", {}, "list").then((res) => {
        res.data.forEach((element) => {
          this.consultores.push({
            id: element.idUsuario,
            label: element.nome,
          });
        });
      });
    },
    buscaFormasdePagamento() {
      var objSend = {};
      objSend.idDistribuidor = this.idDistribuidor;
      service
        .post("CarteiraCobranca", "buscaFormasPagamentoDisponiveis", objSend)
        .then((res) => {
          res.data.forEach((element) => {
            this.formasPagamento.push({
              id: element.idTipoPagamento,
              label: element.nomeTipoPagamento,
            });
          });
          console.log(res.data);
        });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll("g", {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        });
    },
    buscar() {
      this.formFiltro.idDistribuidor = this.decoded.idDistribuidor;
      this.formFiltro.filtred = true;
      this.$emit("filtro", this.formFiltro);
    },
  },
  mounted() {
    this.buscaFormasdePagamento();
    this.buscaSituacoes();
    this.buscaDadosConsultor();
    this.buscaDadosSelects(
      "domStatusRegistrosFinaceiros",
      "statusRegistrosFinanceiros",
      "nomeStatus",
      "idStatus"
    );
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    Datepicker,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
